export enum ShippingCost {
  MINIMUN_UTILITY = 0,
  MAXIMUM_UTILITY = 50,
  MINIMUN_UTILITY_ADDITIONAL_COST_TECLOGI = 5,
  MINIMUN_UTILITY_ADDITIONAL_COST = 0,
}
